export const getReorderedItems = ({ oldIndex = 0, newIndex = 0, items, key = "questionOrder" }: any) => {
  const nextItems = [...items];
  nextItems.splice(newIndex, 0, nextItems.splice(oldIndex, 1)[0]);

  return nextItems.map((item, index) => ({
    ...item,
    [key]: index,
  }));
};
